import usePeriods from "backend/hooks/model/usePeriods";
import { ICardElementWithChildren } from "backend/model/model";
import getValues from "backend/values";
import Todo from "design/components/misc/Todo";
import React from "react";
import { useQuery } from "react-query";
import PerformanceTrendView from "design/components/charts/PerformanceTrendView";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import { Series } from "design/components/charts/types";
import usePeriodLevels from "backend/hooks/model/usePeriodLevels";

const PerformanceTrend = (props: {
  disableAnimation?: boolean;
  element?: ICardElementWithChildren;
  series: Series[];
  width?: string;
}) => {
  const ctx = useAppContext();
  const { data: periods } = usePeriods(props.element?.periodlevel);
  const { data: periodLevels } = usePeriodLevels();
  const { series, width } = props;
  const { data: values } = useQuery(
    `trenddata-${props.element?.id}-${JSON.stringify(periods)}`,
    () => {
      return periods
        ? getValues(props.element?.id || "", periods, false, periodLevels!)
        : [];
    },
    { enabled: !!periodLevels }
  );

  if (!values || values?.length === 0) return null;
  return (
    <div style={{ width: props.width || "720px" }}>
      <PerformanceTrendView
        disableAnimation={props.disableAnimation}
        series={series}
        values={values.filter((v) => v[series[0].key])}
        period={ctx.period || ""}
        width={width || "720px"}
      />
    </div>
  );
};

export default PerformanceTrend;
